'use client';

import { useState, useEffect } from 'react';
import CustomTable from '../../components/CustomTable';
import { ModalAlert } from '@/components/ModalStyled/Modal';
import { HStack, Button, Text, Input } from '@chakra-ui/react';
import { BoxTitle } from '@/components/BoxTitle';
import ModalRetorno from '../../components/ModalRetorno';

interface TableProps {
  headers: any;
  onDelete: (selectedData: any[]) => void;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaTipoCombustivel({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  const [tableData, setTableData] = useState(dados);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newTipoCombustivel, setNewTipoCombustivel] = useState('');

  // Estados para o ModalRetorno (feedback)
  const [modalRetornoOpen, setModalRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState('');
  const [tipoRetorno, setTipoRetorno] = useState<'sucesso' | 'erro'>('sucesso');

  useEffect(() => {
    setTableData(dados);
  }, [dados]);

  const handleDeleteRecords = (selectedData: any[]) => {
    const selectedIds = selectedData.map(item => item.id);
    const newData = tableData.filter(item => !selectedIds.includes(item.id));
    setTableData(newData);
    onDelete(selectedData);
    setMensagemRetorno("Tipo de combustível excluído com sucesso!");
    setTipoRetorno("sucesso");
    setModalRetornoOpen(true);
  };

  const handleAdd = () => {
    if (newTipoCombustivel.trim() !== '') {
      setTableData(prevData => [
        ...prevData,
        { id: prevData.length + 1, tipoCombustivel: newTipoCombustivel, ativo: true },
      ]);
      setNewTipoCombustivel('');
      setIsModalOpen(false);
      setMensagemRetorno("Tipo de combustível adicionado com sucesso!");
      setTipoRetorno("sucesso");
      setModalRetornoOpen(true);
    }
  };

  const handleDataChange = (newData: any[]) => {
    setTableData(newData);
  };

  return (
    <>
      <CustomTable
        headers={headers}
        data={tableData}
        searchValue={valoPesquisa}
        onDelete={handleDeleteRecords}
        onAdd={() => setIsModalOpen(true)}
        onDataChange={handleDataChange}
        addButtonLabel="Adicionar"
        deleteButtonLabel="Excluir"
        showActions={true}
      />

      <ModalAlert
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={<Text fontSize="lg" ml={2}>Adicionar Tipo de combustível</Text>}
        body={
          <HStack mt={3}>
            <BoxTitle title="Tipo de combustível">
              <Input
                placeholder="Adicione um Tipo de combustível"
                value={newTipoCombustivel}
                onChange={(e) => setNewTipoCombustivel(e.target.value)}
              />
            </BoxTitle>
          </HStack>
        }
        footer={
          <Button colorScheme="blue" onClick={handleAdd}>
            Confirmar
          </Button>
        }
      />

      <ModalRetorno
        isOpen={modalRetornoOpen}
        onClose={() => setModalRetornoOpen(false)}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
